import TitlesProps from "./Props/TitlesProps";
import { AreasDeAtuacao, tabContentData } from "../data";
import Watermark from "../Icons/Watermark";

import TextProps from "./Props/TextProps";
import NewTabs from "./Tabs/NewTabs";
import ParceriasProfissionaisSection from "./Tabs/ParceriasProfissionaisSection";

function AreasAtuacao() {
  return (
    <main className="areas-atuacao-container container animate__animated animate__fadeIn">
      <Watermark />
      <TitlesProps data={AreasDeAtuacao} />
      <section className="areas-atuacao-content">
        <TextProps data={AreasDeAtuacao} />
        <NewTabs data={tabContentData} />
        <ParceriasProfissionaisSection />
      </section>
    </main>
  );
}

export default AreasAtuacao;
